/**
 * Map Deepgram word confidence (0–1) → inline style.
 * 1.0 = full white; 0.1 = 10% white (opacity 0.1); unknown = soft gold.
 */
export function confidenceStyle(confidence) {
  if (typeof confidence !== "number" || Number.isNaN(confidence)) {
    return {
      color: "#D4AF37",
      opacity: 0.82,
      fontStyle: "italic",
    };
  }
  const c = Math.min(1, Math.max(0, confidence));
  return {
    color: "#ffffff",
    opacity: c,
    fontStyle: "italic",
  };
}

/** Tooltip / aria label for a word token. */
export function confidenceTitle(confidence) {
  if (typeof confidence !== "number" || Number.isNaN(confidence)) {
    return "Confianza desconocida";
  }
  return `Confianza: ${Math.round(Math.min(1, Math.max(0, confidence)) * 100)}%`;
}
